export const heroesInfo = [
    {
        url:'/dc',
        label:'DC',
        publisher: 'DC Comics'
    },
    {
        url:'/marvel',
        label:'Marvel',
        publisher: 'Marvel Comics'
    },
    {
        url:'/bha',
        label:'BHA',
        publisher: 'Shōnen Jump'
    },
]
